import { useState } from 'react';
import { useSupportChatEnabled } from './useSupportChatEnabled';
import { SupportChat } from './SupportChat';

export function ChatActivationPanel() {
  const { enabled, loading } = useSupportChatEnabled();
  const [open, setOpen] = useState(false);

  return (
    <section className="help-chat-panel">
      <div className="help-chat-icon" aria-hidden="true">
        💬
      </div>
      <div className="help-chat-body">
        <h2 className="help-chat-title">JAD Support Assistant</h2>
        <p className="help-chat-description">
          I'm the JAD Support Assistant — an in-portal helper trained on the AI Calling Portal
          and connected to your account. Unlike a generic chatbot, I check your real data before
          answering, so I can tell you exactly what's happening on your account, not just how
          things work in theory.
        </p>
        <p className="help-chat-list-label">I can help with:</p>
        <ul className="help-chat-list">
          <li>Your credits, platform fee status, and monthly usage</li>
          <li>Why leads were filtered from a recent upload</li>
          <li>Why a Run is empty or when leads become available again</li>
          <li>How your recent call results are trending</li>
          <li>Phone verification job status</li>
          <li>Any question answered by our help guide</li>
        </ul>
        {loading ? (
          <button className="btn btn-primary help-chat-cta" disabled>
            Loading…
          </button>
        ) : enabled ? (
          <button
            className="btn btn-primary help-chat-cta"
            onClick={() => setOpen(true)}
            aria-label="Start a conversation with the support assistant"
          >
            Start Conversation
          </button>
        ) : (
          <button
            className="btn btn-primary help-chat-cta"
            disabled
            title="Chat assistant not yet enabled on your account"
          >
            Start Conversation (coming soon)
          </button>
        )}
      </div>
      {open && <SupportChat onClose={() => setOpen(false)} />}
    </section>
  );
}
